// import React, { FC, useState } from 'react';
// import './index.scss';
// import CardSlot from '@/pages/intelligence/components/CardSlot';
// import { ReactElement } from 'react-markdown/lib/react-markdown';
// import { useSubsidiaryCompanies } from '../hooks';
// import { useCreation, useMemoizedFn } from 'ahooks';
// import { useIntl, useParams, history } from 'umi';
// import Loading from '@/pages/intelligence/components/Loading';
// import { getCountryFlag } from '@/pages/home/_config/countries';
// // type CustomObject<K extends string | number, T> = {
// //   [key in K]: T
// // }

// // type ObjectOfStringValue<S = string> = CustomObject<string, S>;
// // export interface Iprops<S = string, N = number> {
// //   city: S,
// //   company_id: S,
// //   country: S,
// //   country_name_abbre: S,
// //   game_count: N,
// //   img_url: S,
// //   name: S,
// // }
// const ScInfoCard = (): ReactElement => {

//   const { formatMessage } = useIntl()


//   const handleOPenHistory = useMemoizedFn((id: string) => {
//     history.push(`/intelligence/topCharts/companies/gamesDetails/${id}/Summary`);
//   })
//   if (loading) {
//     return <Loading marginTop='25%' />
//   }
//   return (
//     <div className='dbi-scinfocard'>
//       <CardSlot className="dbi-scinfocard-card" >
//         <div className="dbi-scinfocard-item" onClick={() => handleOPenHistory(company_id)}>
//           <div className='dbi-scinfocard-img'>
//             <img src={img_url} alt="" />
//             {/* <LazyLoadImage src={img_url} alt={name} /> */}
//           </div>
//           <div className='dbi-scinfocard-info'>
//             <div className='dbi-scinfocard-title'>{name}</div>
//             <div className='dbi-scinfocard-text'>
//               <img src={getCountryFlag(country_name_abbre?.toLowerCase())} alt="" />
//               {/* <LazyLoadImage src={'https://ogdb-cdn.intlgame.cn/front/static/img/flag0808/us.svg'} alt={name} /> */}
//               <span>{city}</span>
//             </div>
//           </div>
//           <div className='dbi-scinfocard-exit'>
//             <div className='dbi-scinfocard-txt'>Games Owned</div>
//             <div className='dbi-scinfocard-num'>{game_count}</div>
//           </div>
//         </div>
//       </CardSlot>
//     </div>

//   )
// }
// export default ScInfoCard
import React, { FC, } from 'react';
import './index.scss';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { ReactElement } from 'react-markdown/lib/react-markdown';
import { useMemoizedFn } from 'ahooks';
import { useIntl, history } from 'umi';
import { getCountryFlag } from '@/pages/home/_config/countries';
import GameImage from '@/pages/home/components/GameImage';
type CustomObject<K extends string | number, T> = {
  [key in K]: T
}

type ObjectOfStringValue<S = string> = CustomObject<string, S>;
export interface Iprops<S = string, N = number> {
  city: S,
  company_id: S,
  country: S,
  country_name_abbre: S,
  game_count: N,
  img_url: S,
  name: S,
}
const ScInfoCard: FC<Iprops> = ({
  city,
  company_id,
  country_name_abbre,
  game_count,
  img_url,
  name,
}): ReactElement => {
  const { formatMessage } = useIntl()

  const handleOPenHistory = useMemoizedFn((id: string) => {
    history.push(`/intelligence/topCharts/companies/gamesDetails/${id}/Summary`);
  })

  return (
    <div className='dbi-scinfocard'>
      <CardSlot className="dbi-scinfocard-card" >
        <div className="dbi-scinfocard-item" onClick={() => handleOPenHistory(company_id)}>
          <div className='dbi-scinfocard-img'>
            {/* <img src={img_url} alt="" /> */}
            <GameImage
              key={'ScInfoCard'}
              src={img_url}
              entityType={'company'}
            />
            {/* <LazyLoadImage src={img_url} alt={name} /> */}
          </div>
          <div className='dbi-scinfocard-info'>
            <div className='dbi-scinfocard-title'>{name}</div>
            <div className='dbi-scinfocard-text'>
              <img src={getCountryFlag(country_name_abbre?.toLowerCase())} alt="" />
              {/* <LazyLoadImage src={'https://ogdb-cdn.intlgame.cn/front/static/img/flag0808/us.svg'} alt={name} /> */}
              <span>{city}</span>
            </div>
          </div>
          <div className='dbi-scinfocard-exit'>
            <div className='dbi-scinfocard-txt'>{formatMessage({ id: 'dbi_company_game_owned' })}</div>
            <div className='dbi-scinfocard-num'>{game_count || '-'}</div>
          </div>
        </div>
      </CardSlot>
    </div>
  )
}
export default ScInfoCard
